"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.serializeHxSearchTopEntityArgs = void 0;
var HxSearchRefiners_1 = require("./HxSearchRefiners");
function serializeHxSearchTopEntityArgs(_arg) {
    var output = [];
    output.push(_arg.scenario);
    output.push(_arg.maxResultsRequested);
    output.push(_arg.maxTopResultsRequested);
    output.push(_arg.searchRefiners !== undefined);
    if (_arg.searchRefiners !== undefined) {
        output.push(HxSearchRefiners_1.serializeHxSearchRefiners(_arg.searchRefiners));
    }
    return output;
}
exports.serializeHxSearchTopEntityArgs = serializeHxSearchTopEntityArgs;
